export default "__VITE_ASSET__a2f931c3__"